<template>
  <App>
    <datatable
        :filters="filters"
        :headers="headers"
        :items="avaliadoresTable"
        :loading="form.processing"
        singleSearch
    >
      <template #filters>
        <div class="card-title">
          <div class="d-flex align-items-center position-relative">
                        <span class="position-absolute ms-6">
                            <i class="fas fa-search"></i>
                        </span>
            <input data-kt-customer-table-filter="search"
                   v-model="filters.search"
                   type="text"
                   class="form-control form-control-solid w-450px ps-15"
                   placeholder="Nome, E-mail ou CPF"
            />
          </div>
        </div>
        <div class="card-toolbar flex-row-fluid justify-content-end gap-5">

        </div>
      </template>

      <template v-slot:cell.interesses="{row}">
          <span class="badge badge-primary me-2 mt-2" v-if="row.interesses.length > 0" v-for="interesse in row.interesses">{{interesse.Formacao_Nome}}</span>
          <span v-else></span>
      </template>

      <template v-slot:cell.actions="{row}">
        <Link :href="this.route('app.usuarios.edit', row.user_id)"
              method="get"
              as="button"
              type="button"
              class="btn btn-sm btn-clean btn-icon btn-active-light-primary"
              data-bs-toggle="tooltip"
              data-bs-trigger="hover"
              data-bs-delay-show="5000"
              title="Editar avaliador"
              data-bs-original-title="Ver usuário">
          <i class="fs-2 bi bi-pencil-square"></i>
        </Link>
      </template>
    </datatable>
  </App>
</template>
<script>
import App from "@layout/App";
import axios from "axios";
import {ref} from "vue";
import {Link, useForm} from "@inertiajs/inertia-vue3";
import Datatable from "@forms/Datatable";
import SubmitButton from "@forms/SubmitButton";
import Datepicker from "@forms/Datepicker";
import FormGroup from "@forms/FormGroup";
import {success, error} from "@settings/toastr";

export default {
  props: ['avaliadores'],

  components: {
    FormGroup,
    Datepicker,
    SubmitButton,
    App,
    Link,
    Datatable
  },

  data: _ => ({
    headers: [
      {text: 'Código', value: 'id'},
      {text: 'Nome', value: 'AvaliadorNome', searchable: true},
      {text: 'Interesses', value: 'interesses', searchable: false, width: 'w-350px'},
      {text: 'E-mail', value: 'AvaliadorEmail', searchable: true},
      {text: 'CPF', value: 'AvaliadorCPF', searchable: true},
      {text: 'Camiseta', value: 'AvaliadorCamiseta'},
      {text: 'Ações', value: 'actions'},
    ],
    filters: {
      search: '',
    }
  }),

  mounted() {
    this.init();
  },

  setup(props) {
    const avaliadoresTable = ref(props.avaliadores);

    const form = useForm({
      avaliador: null,
    });

    return {
      avaliadoresTable, form
    }
  },

  methods: {
    init() {
      this.emitter.emit('title', 'Avaliadores');
      this.emitter.emit('breadcrumb', [
        {title: 'Dashboard', link: 'app.home'},
        {title: 'Avaliadores'},
      ]);

      this.emitter.emit('action', [{
            show: true,
            title: 'Novo Avaliador',
            link: this.route('app.usuarios.create')
          },
          {
            show: true,
            title: 'Banca Avaliadora',
            link: this.route('app.avaliadores.banca.create')
          }]
      );
    },

    clearFilters() {
      Object.keys(this.filters).forEach(k => this.filters[k] = null);
    },

    list() {
      axios.get(this.route('app.usuarios.filter'))
          .then(response => this.avaliadoresTable = response.data)
    },

    remove(userId) {
      this.form.usuario = userId;
      this.emitter.emit('alert', {
        success: this.confirmDelete
      });
    },

    confirmDelete() {
      this.form.delete(this.route('app.usuarios.delete', {id: this.form.usuario}), {
        onError: error,
        onSuccess: () => {
          success('Usuário excluído com sucesso!');
          this.clearFilters()
          this.list()
        }
      });
    },
  },
};
</script>
